import type { ModuleViewStage } from '@/components/designSystem/QueueViews/types'

import { DSAttendanceDeadlineCalculationType } from './ds-attendance.constants'

/**
 * SLA de Registro de plantão (spec 2026-10-01 §3.1/§3.5/§6.3). Espelho do contrato: os valores
 * são os do backend, copiados literalmente.
 */

export const CONTAINER_STAGES = [
  'AWAITING_SUBMISSION',
  'AWAITING_AUDIT',
  'IN_AUDIT',
  'CLOSED'
] as const
export type ContainerStage = (typeof CONTAINER_STAGES)[number]

/** Etapas com prazo correndo (K1 e "Estado do prazo" só olham estas). */
export const OPEN_CONTAINER_STAGES: readonly ContainerStage[] = [
  'AWAITING_SUBMISSION',
  'AWAITING_AUDIT',
  'IN_AUDIT'
]

/** Chaves do filtro/contador "Estado do prazo" — `NO_SLA` só existe aqui, nunca no item (§6.2). */
export const CONTAINER_SLA_FILTER_STATES = ['OVERDUE', 'ATTENTION', 'ON_TIME', 'NO_SLA'] as const
export type ContainerSlaFilterState = (typeof CONTAINER_SLA_FILTER_STATES)[number]

/** "Agrupar por" do Kanban (URL `agrupar=estado|etapa`, §7.2): K1 e K2. */
export type DsAttendanceGroupBy = 'estado' | 'etapa'

export const CONTAINER_STAGE_LABELS: Record<ContainerStage, string> = {
  AWAITING_SUBMISSION: 'Aguardando envio',
  AWAITING_AUDIT: 'Aguardando auditoria',
  IN_AUDIT: 'Em auditoria',
  CLOSED: 'Encerrado (7 dias)'
}

export const CONTAINER_SLA_FILTER_STATE_LABELS: Record<ContainerSlaFilterState, string> = {
  OVERDUE: 'Vencida',
  ATTENTION: 'Atenção',
  ON_TIME: 'No prazo',
  NO_SLA: 'Sem SLA'
}

/** `DS_ATTENDANCE_STAGES` da §6.3 — a ordem é a do processo (Q4). */
export const DS_ATTENDANCE_STAGES: readonly ModuleViewStage[] = [
  {
    key: 'AWAITING_SUBMISSION',
    label: 'Aguardando envio',
    tone: 'warn',
    order: 1,
    terminal: false,
    hint: 'prazo de envio'
  },
  {
    key: 'AWAITING_AUDIT',
    label: 'Aguardando auditoria',
    tone: 'info',
    order: 2,
    terminal: false,
    hint: 'prazo de auditoria (corre desde a entrada)'
  },
  {
    key: 'IN_AUDIT',
    label: 'Em auditoria',
    tone: 'info',
    order: 3,
    terminal: false,
    hint: 'prazo de auditoria (não pausa)'
  },
  {
    key: 'CLOSED',
    label: 'Encerrado (7 dias)',
    tone: 'ok',
    order: 4,
    terminal: true,
    hint: 'aprovados e rejeitados nos últimos 7 dias'
  }
]

export const DS_ATTENDANCE_CLOSED_WINDOW_DAYS = 7
export const DS_ATTENDANCE_KANBAN_PAGE_SIZE = 25
/** Chave da preferência de visão (`queue-view:ds-attendance`, Q6). */
export const DS_ATTENDANCE_QUEUE_SCREEN_KEY = 'ds-attendance'

/** Rótulo curto do cálculo na linha do prazo ("48 h corridas"). */
export const DEADLINE_CALCULATION_SHORT_LABELS: Record<
  DSAttendanceDeadlineCalculationType,
  string
> = {
  [DSAttendanceDeadlineCalculationType.BUSINESS_HOURS]: 'úteis',
  [DSAttendanceDeadlineCalculationType.CONSECUTIVE_HOURS]: 'corridas'
}
